import React from "react";
import {Link} from "react-router-dom";
import {Icon, Button} from "spectre-react/dist/cjs";
import {editReportPath} from "../../paths";
import {
    BILL_STATE,
    BILL_STATE_LABEL,
    PAYMENT_TYPE,
    PAYMENT_TYPE_LABEL
} from "../shared/constants";
import cx from "classnames";


const EditReportLinkButton = ({reportId, ...rest}) => {
    const path = editReportPath(reportId);

    return (
        <Link className="btn btn-link" to={path} title='Редактировать репорт' {...rest}>
            <Icon icon="edit"/>
        </Link>
    )
}


function getPaymentStatusButtonColor(paymentType) {
    switch (paymentType) {
        case BILL_STATE.ERROR: return 'text-primary';
        case BILL_STATE.NOT_ISSUED: return 'text-primary';
        case BILL_STATE.ISSUED: return 'text-error';
        case BILL_STATE.PART_PAY: return 'text-warning';
        default: return 'text-success';
    }
}

function getPaymentStatusButtonIcon(paymentType) {
    switch (paymentType) {
        case PAYMENT_TYPE.CONTRACT: return 'format_list_numbered';
        case PAYMENT_TYPE.WARRANTY: return 'done';
        case PAYMENT_TYPE.GOODWILL: return 'card_giftcard';
        default: return 'euro_symbol';
    }
}

const PaymentStatusButton = ({paymentType, reportId, ...rest}) => {
    const cls = `btn btn-link ${getPaymentStatusButtonColor(paymentType)}`;
    const title = BILL_STATE_LABEL[paymentType] || PAYMENT_TYPE_LABEL[paymentType];
    const iconName = getPaymentStatusButtonIcon(paymentType);

    return (
        <Button className={cls} data-id={reportId} title={title} {...rest}>
            <i className="material-icons">{iconName}</i>
        </Button>
    )
}


const NotesButton = ({notes, reportId, ...rest}) => {
    const cls = cx("btn btn-link", {"badge text-warning": !!notes});

    return (
        <Button className={cls} data-id={reportId} title="Заметки" {...rest}>
            <i className="material-icons">notes</i>
        </Button>
    )
}


const ApprovalActionButton = ({currentUser, reportId, isApprovedFor, isApprovedOverall, isAssignedToCurrentUser, ...rest}) => {
    // priority_high, pending_actions

    if (currentUser.isLawyer || currentUser.isManagement) {
        const colorCls = cx({
            "text-success": isApprovedOverall,
            "text-warning": !isApprovedOverall && isAssignedToCurrentUser,
            "text-gray": !isApprovedOverall && !isAssignedToCurrentUser
        });

        return (
            <Button link className={colorCls} data-id={reportId} {...rest}>
                {isApprovedOverall && <i className="material-icons">event_available</i>}
                {!isApprovedOverall && <i className="material-icons-outlined">priority_high</i>}
            </Button>
        )
    } else /* if just plain engineer */ {
        const isPresent = (currentUser._id in isApprovedFor);
        const isApproved = isApprovedFor[currentUser._id];

        const colorCls = cx({
            "text-success": isPresent && isApproved,
            "text-warning": isPresent && !isApproved,
            "text-gray": !isPresent
        });

        return (
            <Button link className={colorCls} data-id={reportId} {...rest}>
                {isApprovedOverall && <i className="material-icons">event_available</i>}
                {!isApprovedOverall && <i className="material-icons-outlined">warning</i>}
            </Button>
        )
    }
}


const PDFButton = ({currentUser, reportId, ...rest}) => {
    return (
        <Button link data-id={reportId} title="PDF" {...rest}>
            <i className="material-icons-outlined">picture_as_pdf</i>
        </Button>
    )
}


export {
    EditReportLinkButton,
    ApprovalActionButton,
    PaymentStatusButton,
    NotesButton,
    PDFButton
}